module.exports = __webpack_public_path__ + "img/38.8aaf0a6e.svg";